import React from 'react';
import {
    EffortsWrapper,
    ResultWrapper,
    ShareWrapper,
} from 'features/Big9History/styled';
import Text from 'ui/Text';
import { formatDenmarkCurrency } from 'utils/UiHelper';

const BettingHistoryResults = ({
    spilklub = false,
    winResults = false,
    win = false,
    amountWin = 0,
    amount = 0,
    coupon = false,
    isTerminal = false,
    amountForTerminal = 0,
    isCouponPlaced = true,
}) => {
    return (
        <ResultWrapper spilklub={spilklub && winResults} coupon={coupon}>
            <ShareWrapper>
                <Text
                    size="x07"
                    color={'#333333'}
                    condensed
                    padding="0 0 5px 0"
                >
                    {!spilklub
                        ? 'Indsats'
                        : winResults
                            ? 'Din gevinst'
                            : 'Din andel'}
                </Text>
                <Text
                    size="x15"
                    color={spilklub && win ? '#18AA1B' : '#333333'}
                    condensed
                    padding="0"
                    bold
                >
                    {formatDenmarkCurrency(amount)} kr.
                </Text>
                {isTerminal && (
                    <Text
                        size="x07"
                        color="#333333"
                        condensed
                        padding="0 0 5px 0"
                        margin={'5px 0 0'}
                    >
                        {`Rækkepris: ${formatDenmarkCurrency(
                            amountForTerminal
                        )} kr.`}
                    </Text>
                )}
            </ShareWrapper>
            <EffortsWrapper>
                {((amountWin > 0 && isCouponPlaced) ||
                    (spilklub && isCouponPlaced)) && (
                    <>
                        <Text
                            size="x07"
                            color={'#333333'}
                            condensed
                            padding="0 0 5px 0"
                            align="right"
                        >
                            {!spilklub || coupon
                                ? 'Gevinst'
                                : winResults
                                    ? 'Holdets gevinst'
                                    : 'Holdets indsats'}
                        </Text>
                        <Text
                            size="x15"
                            color={spilklub && win ? '#18AA1B' : '#333333'}
                            condensed
                            padding="0"
                            align="right"
                            bold
                        >
                            {formatDenmarkCurrency(amountWin)} kr.
                        </Text>
                    </>
                )}
            </EffortsWrapper>
        </ResultWrapper>
    );
};

export default BettingHistoryResults;
